module.exports = __webpack_public_path__ + "img/fa6fe6c.png";